import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import serverData from '../../api/ServerData'
import { useNavigate } from 'react-router-dom'
import { isEmpty, showToast } from '../../utils/AppHelper'
import { CircularProgress } from '@mui/material'

export default function ActivateAccount () {
  const navigate = useNavigate()
  const location = useLocation()
  const [error, setError] = useState(false)

  useEffect(function () {
    const query = new URLSearchParams(location.search) // eslint-disable-next-line
    const token = query.get('token')

    if (isEmpty(token)) {
      setError(true)
    } else {
      serverData.activateAccount(
        { token },
        data => {
          if (data?.response?.navigate) {
            navigate(data?.response?.navigate, {
              state: {
                user: data?.response?.user,
                token
              }
            }) // eslint-disable-next-line
          } else {
            navigate('/') // eslint-disable-next-line
          }
        },
        error => {
          showToast(error.statusText)
        }
      )
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center'
      }}
    >
      {error ? (
        <h2 style={{ alignSelf: 'center' }}> Invalid Request</h2>
      ) : (
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CircularProgress />
          <h1>Please wait!</h1>
          <h2>Activating your account...</h2>
        </div>
      )}
    </div>
  )
}
